import BaseService from "./BaseService";

class ReportService {
  static async learningObjectCountSummary({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `reports/learning-objects/summary/counts?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningObjectsSummary({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `reports/learning-objects/summary/objects?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningObjectsUsers({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `reports/learning-objects/users?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningObjectsUsersExcel({
    fileType = "excel",
    query,
    filters,
  }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `reports/learning-objects/users/${fileType}?${queryParams}`,
      "POST",
      {
        filters,
      },
      { responseType: "blob" }
    );
  }

  static async learningMilestonesUsersExcel({
    fileType = "excel",
    query,
    filters,
  }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `reports/learning-milestones/users/${fileType}?${queryParams}`,
      "POST",
      {
        filters,
      },
      { responseType: "blob" }
    );
  }

  static async learningProgramsUsersExcel({
    fileType = "excel",
    query,
    filters,
  }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `reports/learning-programs/users/${fileType}?${queryParams}`,
      "POST",
      {
        filters,
      },
      { responseType: "blob" }
    );
  }

  static async learningProgramCountSummary({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `reports/learning-programs/summary/counts?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningProgramsSummary({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `reports/learning-programs/summary/objects?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningProgramsUsers({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `reports/learning-programs/users?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningMilestoneCountSummary({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `reports/learning-milestones/summary/counts?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningMilestonesSummary({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `reports/learning-milestones/summary/objects?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }

  static async learningMilestonesUsers({ query, filters }) {
    const params = BaseService.cleanQueryParams(query);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `reports/learning-milestones/users?${queryParams}`,
      "POST",
      {
        filters,
      }
    );
  }
}

export default ReportService;
